import * as preact from "preact";
import { $$ } from "../../Core/Common";
import { BaseComponent, IBaseComponentProps } from "../BaseComponent/BaseComponent";
import { $$videoPlayer } from "../VideoPlayer/VideoPlayer";

import Video = EventLibrary.Model.Video;


interface IProps extends IBaseComponentProps
{
    Videos: Video[];
    HideDescription?: boolean;
    HiResImages?: boolean;
}

export class VideoPlayPanel extends BaseComponent<IProps>
{
    constructor(props: IProps)
    {
        super(props);
    }

    _onVideoPanelClick(event)
    {
        let target = $$.getParent(event.target as HTMLElement, "div", "videoThumb");
        if (!target)
        {
            return;
        }

        $$videoPlayer.open(target.dataset.id);
    }

    public render(props: IProps)
    {
        return (
            <div ref={(ref) => this._registerContainer(ref)} class="videoPlayPanel" onClick={this._onVideoPanelClick.bind(this)} >
                {
                  props.Videos?.map((video, index) =>
                  {
                      return (<div data-id={video.Id} className={"videoThumb" + (props.HiResImages? " highRes": "")} key={video.Id} title={props.HideDescription ? video.Description : ""}>
                          <img src={props.HiResImages? "https://i.ytimg.com/vi/" + video.Id + "/hqdefault.jpg": "https://img.youtube.com/vi/" + video.Id + "/1.jpg"} loading="lazy" />
                        {props.HideDescription ? null : <div>{video.Description}</div>}
                    </div>)
                  })
                }
            </div>);
    }
}